/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"

import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import CONSTANT from "../../constant"
import AnzenKanriService from "../../service/driver/anzenKanri/anzenKanriService"
import { T安全管理一覧 } from "../../service/driver/anzenKanri/TAnzenKanri"
import dateUtil from "../../ts/util/dateUtil"
import { TWijmoCellTemplateContext } from "../../type/wijmoComponents"
import EmptyTextHeader from "../FlexGridWrapper/EmptyTextHeader"
import GridFooter from "../FlexGridWrapper/GridFooter"
import LocalAlertComponent from "../LocalAlertComponent"
import { ModalOuter, TModalTypes } from "../Modal/ModalOuter"
import Spinner from "../Spinner"

/**
 * 安全会議検索モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const AnzenKanriSearchModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    setItem: (value: T安全管理一覧) => unknown
  }
> = (props) => {
  //#region [state]
  // 検索項目

  // Grid
  const [pageSize, setPageSize] = useState<number>(50)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjcCore.CollectionView(data, {
      pageSize,
    })

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([], pageSize),
  })
  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
  }

  const search = async (searchCondition?: {}) => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)
    try {
      const res = await new AnzenKanriService().getKanriList({})
      setAlertSource(res)

      const newData = createCollectionView([...res.data], pageSize)
      flexGrid!.itemsSource = newData
      setGridData({ data: newData })
      flexGrid!.refresh()
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSpinnerShow(false)
    }
  }
  /**
   * 選択ハンドラ
   * @param item
   */
  const submitHandler = (item: T安全管理一覧) => {
    props.setItem(item)
    props.setIsShow(false)
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (flexGrid == null) return

    if (props.isShow) {
      //表示時

      // いきなり検索
      search()
    } else {
      // 非表示時中身を空にして閉じる
      const newData = {
        data: createCollectionView([], pageSize),
      }
      if (flexGrid != null) {
        flexGrid.itemsSource = newData.data
        flexGrid.refresh()
      }
      setGridData(newData)
    }
  }, [props.isShow, flexGrid])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "安全会議検索"}
      setIsShow={props.setIsShow}
      size={"xl"}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <div className="search-condition-table">
                <div className="search-condition-row"></div>
              </div>
            </Col>
            <Col className="text-end mb-2">
              <Button
                type="submit"
                onClick={(e) => {
                  e.preventDefault()
                  search()
                }}>
                検索
              </Button>
            </Col>
          </Row>
        </form>
        <Row>
          <Col style={{ height: "35rem" }}>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.Cell}
              initialized={gridInitialized}
              style={{ height: "30rem" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                header="選択"
                align={"center"}
                binding="乗務員安全管理ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(
                    context: TWijmoCellTemplateContext<T安全管理一覧>
                  ) => (
                    <Button onClick={() => submitHandler(context.item)}>
                      選択
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={90}
                header="管理NO"
                binding="管理NO"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={100}
                header="部所CD"
                binding="部所コード"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={200}
                header="部所"
                binding="部所略称"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={200}
                header="会議名"
                binding="会議名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn header="実施日From" binding="実施日FROM">
                <wjrGrid.FlexGridCellTemplate
                  cellType="Cell"
                  template={(
                    context: TWijmoCellTemplateContext<T安全管理一覧>
                  ) => {
                    return dateUtil.format(context.item.実施日FROM)
                  }}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn header="実施日To" binding="実施日TO">
                <wjrGrid.FlexGridCellTemplate
                  cellType="Cell"
                  template={(
                    context: TWijmoCellTemplateContext<T安全管理一覧>
                  ) => {
                    return dateUtil.format(context.item.実施日TO)
                  }}
                />
              </wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
            <GridFooter
              pageSize={pageSize}
              setPageSize={setPageSize}
              gridData={gridData}
              isEnableExport={false}
              flexGrid={flexGrid}></GridFooter>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}

export default AnzenKanriSearchModal
